class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mainProductSelector = document.querySelector('main-product-selector');
    this.overlayButton = this.querySelector('[data-overlay]');
    this.buttonToggle = this.querySelector('[data-button-toggle]');
    this.cardVariants = this.querySelector('card-variants');
    this.cardVariantsButtonClose = this.cardVariants.querySelector(
      '[data-type="close"]',
    );
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);

    this.addEventListener('submit', () => this.buttonToggle.click());
    this.buttonToggle.addEventListener('click', () => {
      this.handleOnButtonToggleClick();

      const productSelector = this.querySelector('product-selector');

      if (productSelector) {
        productSelector.initCarouselAnimation();
      }
    });
    this.cardVariantsButtonClose.addEventListener(
      'click',
      this.handleOnButtonToggleClick.bind(this),
    );
    this.overlayButton.addEventListener('click', () =>
      this.buttonToggle.click(),
    );
    window.addEventListener('scroll', this.handleOnScroll.bind(this));

    this.handleOnScroll();
  }

  handleOnScroll() {
    if (!this.mainProductSelector) return;

    const mainProductSelectorThreshold =
      this.mainProductSelector.offsetHeight * 0.05;
    const footer = document.querySelector('.footer');
    const footerThreshold = footer
      ? footer.offsetTop + footer.offsetHeight * 0.1
      : 0;

    const shouldShow =
      window.scrollY + window.innerHeight <=
        this.mainProductSelector.offsetTop ||
      (window.scrollY >=
        this.mainProductSelector.offsetTop - mainProductSelectorThreshold &&
        window.scrollY + window.innerHeight <= footerThreshold);

    this.classList.toggle('is-visible', shouldShow);
  }

  handleOnButtonToggleClick() {
    this.classList.toggle('has-options-open');
  }

  handleShouldClose(event) {
    const isOpen = this.classList.contains('has-options-open');
    const shouldClose = !(event.target === this || this.contains(event.target));

    if (!shouldClose) return;

    if (isOpen) this.buttonToggle.click();
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);
